import { FeedbackLoader } from '@mail/e.mail.ru.feedback';
import { xray } from 'lib/xray';
import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getFeatureCSATServey } from 'reactApp/modules/features/features.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store } from 'reactApp/store';
import { sendGa } from 'reactApp/utils/ga';
import { put, select } from 'redux-saga/effects';

import { addPromoToShowQueue, promoShown, removePromo } from '../promo.module';
import { PromoSelectors } from '../promo.selectors';
import { EPromoType } from '../promo.types';

const PROMO_ID = 'scat-servey';
const sendCSATGa = (action: string): void => sendGa('csat-servey', action);

let loader: FeedbackLoader | null = null;

const radar = (name, data) => {
    const params: any = { p: 'cloud-web-analytics' };

    if (data) {
        params.dwh = data;
    }

    xray.send(name, params);
};

/**
 * Конфиг в почтовом омикроне
 * https://omicron.mail.ru/projects/4/applications/33/parameters/8668/edit
 */
export function* initCSATServey() {
    const storage = yield select(getCurrentStorage);
    const { isPrivatePage } = getStorage(storage);
    const isBizUser = yield select(UserSelectors.isBizUser);
    const feedbackParams = yield select(getFeatureCSATServey);
    const isPhone = yield select(EnvironmentSelectors.isPhone);

    if (IS_AUTO_TEST_HIDE || !isPrivatePage || !feedbackParams || isBizUser || isPhone) {
        return;
    }

    const email = yield select(UserSelectors.getEmail);

    const {
        // Доля показов в день (джигурда)
        permille = 8,
        // Режим, в котором сам опрос не показывается, но отправляются радары и замеряется аудитория
        dryRun,
        // Интервал между показами (дни) если пользователь проголосовал
        repeatInterval = 180,
        surveyId = 'cloud_daily_csat',
        // Для тестирования, показывает опрос в любом случае
        forced = false,
    } = feedbackParams;

    loader = new FeedbackLoader({
        userId: email,
        surveyId,
        permille,
        radar,
        dryRun,
        repeatInterval,
        forced,
        styles: { zIndex: 1000 },
    });

    yield put(
        addPromoToShowQueue({
            type: EPromoType.csatServey,
            promoId: PROMO_ID,
            onShow: () => {
                sendCSATGa('show');
                store.dispatch(promoShown(EPromoType.csatServey));
            },
            onClose: () => {},
        })
    );

    window.addEventListener('message', (e) => {
        const { action, type } = e?.data || {};

        if (type === 'feedback-evt' && action === 'close') {
            store.dispatch(removePromo(EPromoType.csatServey));
            sendCSATGa('close');
        }
    });
}

export function* showCSATServey() {
    const csatServey = yield select(PromoSelectors.getPromo(EPromoType.csatServey));

    loader
        ?.update()
        .then(() => {
            csatServey.onShow();
        })
        .catch(() => {});
}
